module.exports = __webpack_public_path__ + "static/media/MagneticSwitch.4becc4b4.gif";